import {
  areIntervalsOverlapping,
  startOfDay,
  startOfToday,
  startOfTomorrow
} from 'date-fns';

import type { Interval } from 'components/types';

type Validity = { start: string; end: string };

export const isValidPlanUnit = (
  { start, end }: Validity,
  { startDate, endDate }: Interval
) =>
  areIntervalsOverlapping(
    { start: startOfDay(new Date(start)), end: startOfDay(new Date(end)) },
    { start: startDate, end: endDate }
  );

export const getDefaultInterval = () => ({
  startDate: startOfToday(),
  endDate: startOfTomorrow()
});
